




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Plant from '@/models/plant';
import { list as listPlants } from '@/api/plants';

@Component
export default class PlantList extends Vue {
  plants: Array<Plant> = [];

  async mounted() {
    await this.fetch();
  }

  async fetch() {
    try {
      this.plants = await listPlants();
    } catch (e) {
      this.$toast.open({ message: e.message, type: 'is-danger' });
    }
  }
}
